import React, { useContext, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Button, Callout, DataListItem } from '@node-space/ui-components'
import { MovePayload } from 'pages/NestedCustomers/types'
import { WalletActionContext } from 'pages/Wallets/context/WalletSheetProvider'
import { useInternalTransferDetails } from './hooks/useInternalTransferDetails'

interface MoveConfirmProps {
  formValues: MovePayload
  isLoading: boolean
  transferError?: string
  handleSubmit: () => void
  onBack: () => void
}

export const MoveConfirm = ({
  formValues,
  isLoading,
  transferError,
  handleSubmit,
  onBack,
}: MoveConfirmProps) => {
  const { t } = useTranslation()
  const [walletAction, setWalletAction] = useContext(WalletActionContext)
  const { onClose: handleClose } = walletAction || {}

  useEffect(() => {
    if (onBack) {
      setWalletAction({
        ...walletAction,
        onBack,
      })
    }
  }, [])

  const moveConfirmationDetails = useInternalTransferDetails(formValues)

  return (
    <Box paddingX={24} className="my-6 w-full space-y-4 text-gray-100">
      {!!transferError && <Callout variant="error">{transferError}</Callout>}
      <Box>
        {moveConfirmationDetails.map((row, index) => (
          <DataListItem
            key={index}
            id={row.testid}
            testId={row.testid}
            title={row.label}
            body={row.description}
          />
        ))}
      </Box>
      <Box className="flex justify-between pt-2">
        <Button variant="secondary" onClick={handleClose}>
          {t('cancel')}
        </Button>
        <Button onClick={handleSubmit} loading={isLoading}>
          {t('confirm')}
        </Button>
      </Box>
    </Box>
  )
}
